import { render, staticRenderFns } from "./HlsVideoPlayer.vue?vue&type=template&id=060f04fa&scoped=true"
import script from "./HlsVideoPlayer.vue?vue&type=script&lang=js"
export * from "./HlsVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./HlsVideoPlayer.vue?vue&type=style&index=0&id=060f04fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060f04fa",
  null
  
)

export default component.exports